import * as React from 'react';
import * as PropTypes from 'prop-types'

import { ITranslationContext } from "../../../translations";
import { clickHandler } from '../../../utils/util';
import { IEventReservation, StockItemForBill } from './types';
import ReservationCompetitorCounts from './reservationCompetitorCounts';
import { ReservationType } from '../../../store/pages/diary/types';
import Flag from '../../icons/flag';
import { TimeFormat } from '../../../store/pages/venues/types';
import ReservationInfoLabel from "../diary/reservationInfoLabel";
import StockCounts from './stockCounts';


interface EventReservationProps {
    key: string;
    ix: number;
    reservation: IEventReservation;
    outstandingBal: number;
    expanded: boolean;
    timeFormat: TimeFormat;
    toggleExpandCollapse?: () => void;
    eventStockItems: StockItemForBill[];
}

const EventReservation = (props: EventReservationProps, context: ITranslationContext) => {
    const { key, ix, reservation, outstandingBal, expanded, timeFormat, eventStockItems, toggleExpandCollapse } = props;
    const { t } = context;

    const totalStockItemsForEvent = Math.abs(eventStockItems.reduce((sum, item) => sum + (item.expectedFulfillmentQuantity ?? 0), 0));
    const quantityStockItemsDistributedForEvent = Math.abs(eventStockItems.reduce((sum, item) => sum + (item.confirmedFulfillmentQuantity ?? 0), 0));
    const toggle = toggleExpandCollapse ? toggleExpandCollapse : () => { }
    return <div key={key} onClick={e => clickHandler(e, toggle)} className='reception-reservation-header'>
        <div className='reception-reservation-time'>{reservation.startTime.toShortTimeString(timeFormat)}</div>
        <div className='reception-reservation-resource' style={{ borderLeft: `solid 3px ${reservation.resourceColour}` }}>{reservation.resourceShortName}</div>
        <div className='reception-reservation-type'>{t(reservation.reservationType === ReservationType.Exclusive ? 'Global:exclusiveShort' : 'Global:sharedShort')}</div>
        <div className='reception-reservation-name'>{reservation.activityFormat ? reservation.activityFormat.name : ''}</div>
        <ReservationCompetitorCounts reservation={reservation} />
        <StockCounts totalStockDistributed={quantityStockItemsDistributedForEvent} totalStockForBooking={totalStockItemsForEvent} />
        <div className='reception-booking-outstanding-amount'>{ix === 0 && outstandingBal > 0 ? `${t('Global:currencySymbol')}${outstandingBal.toFixed(2)}` : ''}</div>
        <div className='reception-actions'>{reservation.flagged ? <Flag width={20} height={20} colour='#d9534f' /> : null}{toggleExpandCollapse ? <span className='reception-item-panel-status pull-right'>{expanded ? '-' : '+'}</span> : null}</div>
    </div>
}


EventReservation.contextTypes = {
    t: PropTypes.func
}

export default EventReservation;